import { Navigate } from "react-router-dom";

import { useContentAccess } from "utils/hooks/useContentAccess";

import { TutoringRoutes } from "./index";
import TutoringPracticePage from "./Practice";

/**
 * AIDEV-NOTE: Maturant doučování nemá — a na rozdíl od maturitní četby si ho
 * nemůže dokoupit, takže tady nabídka upgradu nedává smysl a jde se na nástěnku.
 * Skrytí v menu nestačí, `/doucovani/cesky-jazyk` je průchozí URL. [TD-351]
 */
export const TutoringGuard = () => {
  const { tutoringVisible } = useContentAccess();

  if (!tutoringVisible) return <Navigate to="/" replace />;

  return <TutoringRoutes />;
};

/**
 * AIDEV-NOTE: Vlastní guard pro `doucovani/:subjectSlug/:tutoringId` — ta routa sedí
 * v jiném layoutu (`LayoutSimpleWide`) mimo `doucovani/*` a react-router v6 vybírá
 * podle specificity, ne podle pořadí, takže konkrétnější segmenty vyhrají nad splatem
 * a guard výš se pro ni vůbec nespustí. Bez tohohle obalu je průchozí i pro maturanta,
 * a to běžným klikáním z detailu tématu, ne jen vpisem URL. [TD-351]
 */
export const TutoringPracticeGuard = () => {
  const { tutoringVisible } = useContentAccess();

  if (!tutoringVisible) return <Navigate to="/" replace />;

  return <TutoringPracticePage />;
};
